import {Component} from '@angular/core';

/**
 * This component is required as the background layer of a modal component
 */
@Component({selector: 'ngb-modal-backdrop', template: '', host: {class: 'modal-backdrop fade show'}})
export class ModalBackdropComponent {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/widgets/slide-in-modal/components/modal-backdrop.component.ts